import { render, staticRenderFns } from "./Painel.vue?vue&type=template&id=bd31f1c0"
import script from "./Painel.vue?vue&type=script&lang=js"
export * from "./Painel.vue?vue&type=script&lang=js"
import style0 from "./Painel.vue?vue&type=style&index=0&id=bd31f1c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports